// import { useEffect, useState } from "react";
// import NavbarComp from "../components/navbar";
// import { useLocation } from "react-router-dom";
// import axios from "axios";
// import CreateDirectory from "./CreateDirectory";
// import { CircularProgress } from "@mui/material";

// import {
//     DragDropContext,
//     Droppable,
//     Draggable,
// } from "react-beautiful-dnd";

// const EditDirectory = () => {
//     const location = useLocation();
//     const [data, setData] = useState([]);
//     const [search, setSearch] = useState("");
//     const [activeCategory, setActiveCategory] = useState("All Directory");
//     const [sortConfig, setSortConfig] = useState({ key: null, direction: null });
//     const backendURL = process.env.REACT_APP_BACKEND_URL;
//     const [isLoading, setIsLoading] = useState(false);

//     const [editItem, setEditItem] = useState(null);
//     const [isEditOpen, setIsEditOpen] = useState(false);

//     const handleEdit = (item) => {
//         setEditItem(item);
//         setIsEditOpen(true);
//     };

//     const handleEditClose = () => {
//         setEditItem(null);
//         setIsEditOpen(false);
//     };

//     const fetchData = async () => {
//         try {
//             setIsLoading(true);
//             let response;
//             if (activeCategory === "All Directory") {
//                 response = await axios.get(`${backendURL}/api/directory`);
//             } else {
//                 const categoryMap = {
//                     Business: "business",
//                     "Church Lodges": "church_lodges",
//                     "Natural Healers": "natural_healers",
//                 };
//                 const categoryParam = categoryMap[activeCategory];
//                 response = await axios.get(
//                     `${backendURL}/api/directory/type/${categoryParam}`
//                 );
//             }

//             // Ensure response data is an array and sorted by order
//             let directoryArray = Array.isArray(response.data)
//                 ? response.data
//                 : response.data.data;

//             if (directoryArray && directoryArray.length) {
//                 directoryArray.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
//             }

//             setData(directoryArray || []);
//             setIsLoading(false);
//         } catch (error) {
//             console.error("Error fetching directory data:", error);
//             setData([]);
//             setIsLoading(false);
//         }
//     };

//     useEffect(() => {
//         fetchData();
//     }, [activeCategory, backendURL]);

//     // Same search and sort logic as before:
//     const filteredData = data.filter((item) => {
//         const itemLocation = (item.location || "").toLowerCase();
//         const keywordsString = Array.isArray(item.keywords)
//             ? item.keywords.join(" ").toLowerCase()
//             : (item.keywords || "").toLowerCase();

//         const itemData = `${itemLocation} ${keywordsString}`;
//         const searchWords = search.toLowerCase().split(/\s+/).filter(Boolean);
//         const matchesSearch =
//             searchWords.length === 0 ||
//             searchWords.every((word) => itemData.includes(word));

//         return matchesSearch;
//     });

//     const sortedData = [...filteredData].sort((a, b) => {
//         if (!sortConfig.key) return 0;
//         const valA = (a[sortConfig.key] || "").toLowerCase();
//         const valB = (b[sortConfig.key] || "").toLowerCase();

//         if (valA < valB) return sortConfig.direction === "asc" ? -1 : 1;
//         if (valA > valB) return sortConfig.direction === "asc" ? 1 : -1;
//         return 0;
//     });

//     const handleSort = (key, direction) => {
//         setSortConfig({ key, direction });
//     };

//     // NEW: On drag end handler
//     const onDragEnd = async (result) => {
//         if (!result.destination) return; // dropped outside

//         const sourceIndex = result.source.index;
//         const destinationIndex = result.destination.index;

//         if (sourceIndex === destinationIndex) return; // no change

//         // Reorder the sortedData array locally
//         const reordered = Array.from(sortedData);
//         const [movedItem] = reordered.splice(sourceIndex, 1);
//         reordered.splice(destinationIndex, 0, movedItem);

//         // Update order property for all items based on new index
//         const updatedWithOrder = reordered.map((item, index) => ({
//             ...item,
//             order: index,
//         }));

//         setData((prevData) => {
//             // Update original data array order accordingly for future fetches
//             // We replace matching items by id with updated order, keep others same
//             return prevData.map((item) => {
//                 const updatedItem = updatedWithOrder.find((u) => u._id === item._id || u.id === item.id);
//                 return updatedItem ? { ...item, order: updatedItem.order } : item;
//             });
//         });

//         try {
//             // Send updated order to backend
//             // Backend expects [{id, order}]
//             const orderPayload = updatedWithOrder.map((item) => ({
//                 id: item._id || item.id,
//                 order: item.order,
//             }));

//             await axios.put(`${process.env.REACT_APP_BACKEND_URL}/api/directory/update-order`, { orders: orderPayload });
//             // Optionally, refetch data if you want to be sure
//             await fetchData();
//         } catch (error) {
//             console.error("Failed to update order", error);
//             // Optionally revert UI changes or notify user
//         }
//     };

//     if (isLoading) {
//         return (
//             <div
//                 style={{
//                     display: "flex",
//                     justifyContent: "center",
//                     alignItems: "center",
//                     minHeight: "200px",
//                 }}
//             >
//                 <CircularProgress />
//             </div>
//         );
//     }

//     return (
//         <div className="bg-gray-100 min-h-screen">
//             {location.pathname === "/directory" && <NavbarComp />}

//             {isEditOpen && (
//                 <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 px-4">
//                     <div className="bg-white p-6 rounded-lg w-full max-w-3xl shadow-lg max-h-[90vh] overflow-y-auto">
//                         <CreateDirectory
//                             editData={editItem}
//                             onClose={handleEditClose}
//                             onSuccess={() => {
//                                 handleEditClose();
//                                 fetchData();
//                             }}
//                         />
//                     </div>
//                 </div>
//             )}

//             <div className="max-w-[1600px] mx-auto px-4 py-8">
//                 <div className="mb-12 flex items-center gap-4">
//                     <label
//                         htmlFor="search"
//                         className="text-3xl font-bold text-gray-800 whitespace-nowrap"
//                     >
//                         Search:
//                     </label>
//                     <input
//                         type="text"
//                         id="search"
//                         placeholder="Location or Keywords..."
//                         value={search}
//                         onChange={(e) => setSearch(e.target.value)}
//                         className="w-8/12 px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
//                     />
//                 </div>

//                 <div className="flex flex-wrap gap-4 mb-8 justify-center">
//                     {["All Directory", "Business", "Church Lodges", "Natural Healers"].map(
//                         (category) => (
//                             <button
//                                 key={category}
//                                 onClick={() => setActiveCategory(category)}
//                                 className={`px-4 py-2 rounded-full font-semibold transition-colors ${activeCategory === category
//                                     ? "bg-blue-600 text-white shadow-lg"
//                                     : "bg-blue-100 text-blue-800 hover:bg-blue-200"
//                                     }`}
//                             >
//                                 {category}
//                             </button>
//                         )
//                     )}
//                 </div>

//                 {/* DragDropContext + Droppable wrapping table body */}
//                 <div className="mt-10 bg-white rounded-lg shadow-md w-full overflow-x-auto">
//                     <table className="w-full divide-y divide-gray-200 text-center table-fixed">
//                         <thead className="bg-gradient-to-r from-blue-500 to-purple-500 text-white">
//                             <tr className="divide-x divide-white">
//                                 {/* ... your headers (unchanged) ... */}
//                                 <th className="px-4 py-3 text-xs font-medium uppercase tracking-wider text-left relative group">
//                                     <div className="flex items-center justify-between">
//                                         <span>Name</span>
//                                         <div className="relative">
//                                             <button className="ml-1">
//                                                 <span className="text-white">▼</span>
//                                             </button>
//                                             <div className="absolute right-0 mt-2 hidden group-hover:block bg-white text-black border border-gray-200 shadow-lg rounded-md z-50 w-40 animate-fade-in">
//                                                 <div
//                                                     onClick={() => handleSort("name", "asc")}
//                                                     className="px-4 py-2 hover:bg-blue-100 cursor-pointer rounded-t-md transition-all"
//                                                 >
//                                                     Sort A → Z
//                                                 </div>
//                                                 <div
//                                                     onClick={() => handleSort("name", "desc")}
//                                                     className="px-4 py-2 hover:bg-blue-100 cursor-pointer rounded-b-md transition-all"
//                                                 >
//                                                     Sort Z → A
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </th>

//                                 <th className="px-4 py-3 text-xs font-medium uppercase tracking-wider text-left relative group">
//                                     <div className="flex items-center justify-between">
//                                         <span>Location</span>
//                                         <div className="relative">
//                                             <button className="ml-1">
//                                                 <span className="text-white">▼</span>
//                                             </button>
//                                             <div className="absolute right-0 mt-2 hidden group-hover:block bg-white text-black border border-gray-200 shadow-lg rounded-md z-50 w-40 animate-fade-in">
//                                                 <div
//                                                     onClick={() => handleSort("location", "asc")}
//                                                     className="px-4 py-2 hover:bg-blue-100 cursor-pointer rounded-t-md transition-all"
//                                                 >
//                                                     Sort A → Z
//                                                 </div>
//                                                 <div
//                                                     onClick={() => handleSort("location", "desc")}
//                                                     className="px-4 py-2 hover:bg-blue-100 cursor-pointer rounded-b-md transition-all"
//                                                 >
//                                                     Sort Z → A
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </th>
//                                 <th className="px-4 py-3 text-xs font-medium uppercase tracking-wider w-1/3">Information</th>
//                                 <th className="px-4 py-3 text-xs font-medium uppercase tracking-wider">Keywords</th>
//                                 <th className="px-4 py-3 text-xs font-medium uppercase tracking-wider">Email</th>
//                                 <th className="px-4 py-3 text-xs font-medium uppercase tracking-wider">Website</th>
//                                 <th className="px-4 py-3 text-xs font-medium uppercase tracking-wider">Action</th>
//                             </tr>
//                         </thead>

//                         <DragDropContext onDragEnd={onDragEnd}>
//                             <Droppable droppableId="directoryList">
//                                 {(provided) => (
//                                     <tbody
//                                         {...provided.droppableProps}
//                                         ref={provided.innerRef}
//                                         className="divide-y divide-gray-200"
//                                     >
//                                         {sortedData.map((item, index) => (
//                                             <Draggable
//                                                 key={item._id || item.id}
//                                                 draggableId={String(item._id || item.id)}
//                                                 index={index}
//                                             >
//                                                 {(provided, snapshot) => (
//                                                     <tr
//                                                         ref={provided.innerRef}
//                                                         {...provided.draggableProps}
//                                                         {...provided.dragHandleProps}
//                                                         className={`cursor-move ${snapshot.isDragging ? "bg-gray-100" : ""
//                                                             }`}
//                                                     >
//                                                         <td className="whitespace-normal px-4 py-3 text-left max-w-xs break-words">
//                                                             {item.name}
//                                                         </td>
//                                                         <td className="whitespace-normal px-4 py-3 text-left max-w-xs break-words">
//                                                             {item.location}
//                                                         </td>
//                                                         <td className="px-4 py-3 text-left max-w-[400px] break-words text-sm">{item.info || "N/A"}</td>

//                                                         <td className="whitespace-normal px-4 py-3 text-left max-w-xs break-words">
//                                                             {Array.isArray(item.keywords)
//                                                                 ? item.keywords.join(", ")
//                                                                 : item.keywords}
//                                                         </td>
//                                                         <td className="px-4 py-3 break-words w-[220px] text-sm">
//                                                             {item.email ? (
//                                                                 <a
//                                                                     href={`mailto:${item.email}`}
//                                                                     className="text-blue-600 hover:underline break-all block"
//                                                                 >
//                                                                     {item.email}
//                                                                 </a>
//                                                             ) : "N/A"}
//                                                         </td>
//                                                         <td className="px-4 py-3 break-words w-[220px]">
//                                                             {item.website && item.website !== "N/A" ? (
//                                                                 <a href={item.website.startsWith("http") ? item.website : `https://${item.website}`} target="_blank" rel="noreferrer" className="text-blue-600 hover:underline">{item.website}</a>
//                                                             ) : "N/A"}
//                                                         </td>
//                                                         <td className="flex items-center justify-center space-x-4 whitespace-normal px-4 py-3 text-left max-w-xs break-words">
//                                                             <button
//                                                                 onClick={() => handleEdit(item)}
//                                                                 className="text-blue-600 hover:underline"
//                                                             >
//                                                                 Edit
//                                                             </button>
//                                                         </td>
//                                                     </tr>
//                                                 )}
//                                             </Draggable>
//                                         ))}
//                                         {provided.placeholder}
//                                     </tbody>
//                                 )}
//                             </Droppable>
//                         </DragDropContext>
//                     </table>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default EditDirectory;





import { useEffect, useState } from "react";
import NavbarComp from "../components/navbar";
import { useLocation } from "react-router-dom";
import axios from "axios";
import CreateDirectory from "./CreateDirectory";
import { CircularProgress } from "@mui/material";

import {
    DragDropContext,
    Droppable,
    Draggable,
} from "react-beautiful-dnd";

const EditDirectory = () => {
    const location = useLocation();
    const [data, setData] = useState([]);
    const [search, setSearch] = useState("");
    const [activeCategory, setActiveCategory] = useState("All Directory");
    const [sortConfig, setSortConfig] = useState({ key: null, direction: null });
    const backendURL = process.env.REACT_APP_BACKEND_URL;
    const [isLoading, setIsLoading] = useState(false);

    const [editItem, setEditItem] = useState(null);
    const [isEditOpen, setIsEditOpen] = useState(false);

    const handleEdit = (item) => {
        setEditItem(item);
        setIsEditOpen(true);
    };

    const handleEditClose = () => {
        setEditItem(null);
        setIsEditOpen(false);
    };

    const fetchData = async () => {
        try {
            setIsLoading(true);
            let response;
            if (activeCategory === "All Directory") {
                response = await axios.get(`${backendURL}/api/directory`);
            } else {
                const categoryMap = {
                    Business: "business",
                    "Church Lodges": "church_lodges",
                    "Natural Healers": "natural_healers",
                };
                const categoryParam = categoryMap[activeCategory];
                response = await axios.get(
                    `${backendURL}/api/directory/type/${categoryParam}`
                );
            }

            // Ensure response data is an array and sorted by order
            let directoryArray = Array.isArray(response.data)
                ? response.data
                : response.data.data;

            if (directoryArray && directoryArray.length) {
                directoryArray.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
            }

            setData(directoryArray || []);
            setIsLoading(false);
        } catch (error) {
            console.error("Error fetching directory data:", error);
            setData([]);
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, [activeCategory, backendURL]);

    // Same search and sort logic as before:
    const filteredData = data.filter((item) => {
        const itemLocation = (item.location || "").toLowerCase();
        const keywordsString = Array.isArray(item.keywords)
            ? item.keywords.join(" ").toLowerCase()
            : (item.keywords || "").toLowerCase();

        const itemData = `${itemLocation} ${keywordsString}`;
        const searchWords = search.toLowerCase().split(/\s+/).filter(Boolean);
        const matchesSearch =
            searchWords.length === 0 ||
            searchWords.every((word) => itemData.includes(word));

        return matchesSearch;
    });

    const sortedData = [...filteredData].sort((a, b) => {
        if (!sortConfig.key) return 0;
        const valA = (a[sortConfig.key] || "").toLowerCase();
        const valB = (b[sortConfig.key] || "").toLowerCase();

        if (valA < valB) return sortConfig.direction === "asc" ? -1 : 1;
        if (valA > valB) return sortConfig.direction === "asc" ? 1 : -1;
        return 0;
    });

    const handleSort = (key, direction) => {
        setSortConfig({ key, direction });
    };

    // NEW: On drag end handler
    const onDragEnd = async (result) => {
        if (!result.destination) return; // dropped outside

        const sourceIndex = result.source.index;
        const destinationIndex = result.destination.index;

        if (sourceIndex === destinationIndex) return; // no change

        // Reorder the sortedData array locally
        const reordered = Array.from(sortedData);
        const [movedItem] = reordered.splice(sourceIndex, 1);
        reordered.splice(destinationIndex, 0, movedItem);

        // Update order property for all items based on new index
        const updatedWithOrder = reordered.map((item, index) => ({
            ...item,
            order: index,
        }));

        setData((prevData) => {
            // Update original data array order accordingly for future fetches
            // We replace matching items by id with updated order, keep others same
            return prevData.map((item) => {
                const updatedItem = updatedWithOrder.find((u) => u._id === item._id || u.id === item.id);
                return updatedItem ? { ...item, order: updatedItem.order } : item;
            });
        });

        try {
            // Send updated order to backend
            // Backend expects [{id, order}]
            const orderPayload = updatedWithOrder.map((item) => ({
                id: item._id || item.id,
                order: item.order,
            }));

            await axios.put(`${process.env.REACT_APP_BACKEND_URL}/api/directory/update-order`, { orders: orderPayload });
            // Optionally, refetch data if you want to be sure
            await fetchData();
        } catch (error) {
            console.error("Failed to update order", error);
            // Optionally revert UI changes or notify user
        }
    };

    if (isLoading) {
        return (
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    minHeight: "200px",
                }}
            >
                <CircularProgress />
            </div>
        );
    }

    return (
        <div className="bg-gray-100 min-h-screen">
            {location.pathname === "/directory" && <NavbarComp />}

            {isEditOpen && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 px-4">
                    <div className="bg-white p-6 rounded-lg w-full max-w-3xl shadow-lg max-h-[90vh] overflow-y-auto">
                        <CreateDirectory
                            editData={editItem}
                            onClose={handleEditClose}
                            onSuccess={() => {
                                handleEditClose();
                                fetchData();
                            }}
                        />
                    </div>
                </div>
            )}

            <div className="max-w-[1600px] mx-auto px-4 py-8">
                <div className="mb-12 flex items-center gap-4">
                    <label
                        htmlFor="search"
                        className="text-xl md:text-3xl font-bold text-gray-800 whitespace-nowrap"
                    >
                        Search:
                    </label>
                    <input
                        type="text"
                        id="search"
                        placeholder="Location or Keywords..."
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        className="w-8/12 px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                    />
                </div>

                <div className="flex flex-wrap gap-4 mb-8 justify-center">
                    {["All Directory", "Business", "Church Lodges", "Natural Healers"].map(
                        (category) => (
                            <button
                                key={category}
                                onClick={() => setActiveCategory(category)}
                                className={`px-4 py-2 rounded-full font-semibold transition-colors ${activeCategory === category
                                    ? "bg-blue-600 text-white shadow-lg"
                                    : "bg-blue-100 text-blue-800 hover:bg-blue-200"
                                    }`}
                            >
                                {category}
                            </button>
                        )
                    )}
                </div>

                {/* DragDropContext + Droppable wrapping table body */}
                {/* <div className="mt-10 bg-white rounded-lg shadow-md w-full overflow-x-auto">
                    <table className="min-w-[800px] w-full divide-y divide-gray-200 text-center">
                        <thead className="bg-gradient-to-r from-blue-500 to-purple-500 text-white">
                            <tr className="divide-x divide-white text-sm">
                                <th className="px-4 py-3 text-left whitespace-nowrap min-w-[150px] relative group">
                                    <div className="flex items-center justify-between">
                                        <span>Name</span>
                                        <div className="relative">
                                            <button className="ml-1">
                                                <span className="text-white">▼</span>
                                            </button>
                                            <div className="absolute right-0 mt-2 hidden group-hover:block bg-white text-black border border-gray-200 shadow-lg rounded-md z-50 w-40 animate-fade-in">
                                                <div
                                                    onClick={() => handleSort("name", "asc")}
                                                    className="px-4 py-2 hover:bg-blue-100 cursor-pointer rounded-t-md transition-all"
                                                >
                                                    Sort A → Z
                                                </div>
                                                <div
                                                    onClick={() => handleSort("name", "desc")}
                                                    className="px-4 py-2 hover:bg-blue-100 cursor-pointer rounded-b-md transition-all"
                                                >
                                                    Sort Z → A
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </th>

                                <th className="px-4 py-3 text-xs font-medium uppercase tracking-wider text-left relative group">
                                    <div className="flex items-center justify-between">
                                        <span>Location</span>
                                        <div className="relative">
                                            <button className="ml-1">
                                                <span className="text-white">▼</span>
                                            </button>
                                            <div className="absolute right-0 mt-2 hidden group-hover:block bg-white text-black border border-gray-200 shadow-lg rounded-md z-50 w-40 animate-fade-in">
                                                <div
                                                    onClick={() => handleSort("location", "asc")}
                                                    className="px-4 py-2 hover:bg-blue-100 cursor-pointer rounded-t-md transition-all"
                                                >
                                                    Sort A → Z
                                                </div>
                                                <div
                                                    onClick={() => handleSort("location", "desc")}
                                                    className="px-4 py-2 hover:bg-blue-100 cursor-pointer rounded-b-md transition-all"
                                                >
                                                    Sort Z → A
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </th>
                                <th className="px-4 py-3 text-xs font-medium uppercase tracking-wider w-1/3">Information</th>
                                <th className="px-4 py-3 text-xs font-medium uppercase tracking-wider">Keywords</th>
                                <th className="px-4 py-3 text-xs font-medium uppercase tracking-wider">Email</th>
                                <th className="px-4 py-3 text-xs font-medium uppercase tracking-wider">Website</th>
                                <th className="px-4 py-3 text-xs font-medium uppercase tracking-wider">Action</th>
                            </tr>
                        </thead>

                        <DragDropContext onDragEnd={onDragEnd}>
                            <Droppable droppableId="directoryList">
                                {(provided) => (
                                    <tbody
                                        {...provided.droppableProps}
                                        ref={provided.innerRef}
                                        className="divide-y divide-gray-200"
                                    >
                                        {sortedData.map((item, index) => (
                                            <Draggable
                                                key={item._id || item.id}
                                                draggableId={String(item._id || item.id)}
                                                index={index}
                                            >
                                                {(provided, snapshot) => (
                                                    <tr
                                                        ref={provided.innerRef}
                                                        {...provided.draggableProps}
                                                        {...provided.dragHandleProps}
                                                        className={`cursor-move ${snapshot.isDragging ? "bg-gray-100" : ""
                                                            }`}
                                                    >
                                                        <td className="whitespace-normal px-4 py-3 text-left max-w-xs break-words">
                                                            {item.name}
                                                        </td>
                                                        <td className="whitespace-normal px-4 py-3 text-left max-w-xs break-words">
                                                            {item.location}
                                                        </td>
                                                        <td className="px-4 py-3 text-left max-w-[400px] break-words text-sm">{item.info || "N/A"}</td>

                                                        <td className="whitespace-normal px-4 py-3 text-left max-w-xs break-words">
                                                            {Array.isArray(item.keywords)
                                                                ? item.keywords.join(", ")
                                                                : item.keywords}
                                                        </td>
                                                        <td className="px-4 py-3 break-words w-[220px] text-sm">
                                                            {item.email ? (
                                                                <a
                                                                    href={`mailto:${item.email}`}
                                                                    className="text-blue-600 hover:underline break-all block"
                                                                >
                                                                    {item.email}
                                                                </a>
                                                            ) : "N/A"}
                                                        </td>
                                                        <td className="px-4 py-3 break-words w-[220px]">
                                                            {item.website && item.website !== "N/A" ? (
                                                                <a href={item.website.startsWith("http") ? item.website : `https://${item.website}`} target="_blank" rel="noreferrer" className="text-blue-600 hover:underline">{item.website}</a>
                                                            ) : "N/A"}
                                                        </td>
                                                        <td className="flex items-center justify-center space-x-4 whitespace-normal px-4 py-3 text-left max-w-xs break-words">
                                                            <button
                                                                onClick={() => handleEdit(item)}
                                                                className="text-blue-600 hover:underline"
                                                            >
                                                                Edit
                                                            </button>
                                                        </td>
                                                    </tr>
                                                )}
                                            </Draggable>
                                        ))}
                                        {provided.placeholder}
                                    </tbody>
                                )}
                            </Droppable>
                        </DragDropContext>
                    </table>
                </div> */}

                <div className="mt-10 bg-white rounded-lg shadow-md w-full overflow-x-auto">
                    <table className="min-w-[800px] w-full divide-y divide-gray-200 text-sm text-left">
                        <thead className="bg-gradient-to-r from-blue-500 to-purple-500 text-white">
                            <tr className="divide-x divide-white">
                                <th className="px-4 py-3 min-w-[150px] relative group">
                                    <div className="flex items-center justify-between">
                                        <span>Name</span>
                                        <div className="relative">
                                            <button className="ml-1 text-white">▼</button>
                                            <div className="absolute left-0 mt-2 hidden group-hover:block bg-white text-black border border-gray-200 shadow-lg rounded-md z-50 min-w-[10rem] animate-fade-in">
                                                <div
                                                    onClick={() => handleSort("name", "asc")}
                                                    className="px-4 py-2 hover:bg-blue-100 cursor-pointer rounded-t-md transition-all"
                                                >
                                                    Sort A → Z
                                                </div>
                                                <div
                                                    onClick={() => handleSort("name", "desc")}
                                                    className="px-4 py-2 hover:bg-blue-100 cursor-pointer rounded-b-md transition-all"
                                                >
                                                    Sort Z → A
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </th>
                                <th className="px-4 py-3 min-w-[150px] relative group">
                                    <div className="flex items-center justify-between">
                                        <span>Location</span>
                                        <div className="relative">
                                            <button className="ml-1 text-white">▼</button>
                                            <div className="absolute left-0 mt-2 hidden group-hover:block bg-white text-black border border-gray-200 shadow-lg rounded-md z-50 min-w-[10rem] animate-fade-in">
                                                <div
                                                    onClick={() => handleSort("location", "asc")}
                                                    className="px-4 py-2 hover:bg-blue-100 cursor-pointer rounded-t-md transition-all"
                                                >
                                                    Sort A → Z
                                                </div>
                                                <div
                                                    onClick={() => handleSort("location", "desc")}
                                                    className="px-4 py-2 hover:bg-blue-100 cursor-pointer rounded-b-md transition-all"
                                                >
                                                    Sort Z → A
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </th>
                                <th className="px-4 py-3 min-w-[200px]">Information</th>
                                <th className="px-4 py-3 min-w-[150px]">Keywords</th>
                                <th className="px-4 py-3 min-w-[200px]">Email</th>
                                <th className="px-4 py-3 min-w-[200px]">Website</th>
                                <th className="px-4 py-3 min-w-[100px]">Action</th>
                            </tr>
                        </thead>

                        <DragDropContext onDragEnd={onDragEnd}>
                            <Droppable droppableId="directoryList">
                                {(provided) => (
                                    <tbody
                                        {...provided.droppableProps}
                                        ref={provided.innerRef}
                                        className="divide-y divide-gray-200"
                                    >
                                        {sortedData.map((item, index) => (
                                            <Draggable
                                                key={item._id || item.id}
                                                draggableId={String(item._id || item.id)}
                                                index={index}
                                            >
                                                {(provided, snapshot) => (
                                                    <tr
                                                        ref={provided.innerRef}
                                                        {...provided.draggableProps}
                                                        {...provided.dragHandleProps}
                                                        className={`cursor-move ${snapshot.isDragging ? "bg-gray-100" : ""
                                                            } hover:bg-gray-50 transition`}
                                                    >
                                                        <td className="px-4 py-3 text-left break-words max-w-[200px]">
                                                            {item.name || "N/A"}
                                                        </td>
                                                        <td className="px-4 py-3 text-left break-words max-w-[200px]">
                                                            {item.location || "N/A"}
                                                        </td>
                                                        <td className="px-4 py-3 text-left break-words max-w-[400px]">
                                                            {item.info || "N/A"}
                                                        </td>
                                                        <td className="px-4 py-3 text-left break-words max-w-[250px]">
                                                            {Array.isArray(item.keywords)
                                                                ? item.keywords.join(", ")
                                                                : item.keywords || "N/A"}
                                                        </td>
                                                        <td className="px-4 py-3 break-words max-w-[250px]">
                                                            {item.email ? (
                                                                <a
                                                                    href={`mailto:${item.email}`}
                                                                    className="text-blue-600 hover:underline break-all block"
                                                                >
                                                                    {item.email}
                                                                </a>
                                                            ) : "N/A"}
                                                        </td>
                                                        <td className="px-4 py-3 break-words max-w-[250px]">
                                                            {item.website && item.website !== "N/A" ? (
                                                                <a
                                                                    href={item.website.startsWith("http") ? item.website : `https://${item.website}`}
                                                                    target="_blank"
                                                                    rel="noreferrer"
                                                                    className="text-blue-600 hover:underline"
                                                                >
                                                                    {item.website}
                                                                </a>
                                                            ) : "N/A"}
                                                        </td>
                                                        <td className="px-4 py-3 text-center">
                                                            <button
                                                                onClick={() => handleEdit(item)}
                                                                className="text-blue-600 hover:underline"
                                                            >
                                                                Edit
                                                            </button>
                                                        </td>
                                                    </tr>
                                                )}
                                            </Draggable>
                                        ))}
                                        {provided.placeholder}
                                    </tbody>
                                )}
                            </Droppable>
                        </DragDropContext>
                    </table>
                </div>

            </div>
        </div>
    );
};

export default EditDirectory;





